import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=97b85ba6"
import script from "./inputNumber.vue?vue&type=script&lang=js"
export * from "./inputNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports